export function actions_reloadApp() {
  window.location.reload();
}
